const $ = jQuery;

export class LanguageSwitcher {
	/**
	 *
	 * @param {HTMLElement} element jQuery element of the language switcher
	 * @param {{prefix: String, location: String, transitionDuration: Number} } options Options for the language switcher
	 */
	constructor(element, options = {}) {
		const { prefix, location, transitionDuration } = options;
		this.element = element;
		this.location = location || element.data("location");
		this.openState = false;
		this.prefix = prefix || "language-switcher";
		this.trigger = this.getTrigger();
		this.dropdown = this.getDropdown();
		this.transitionDuration = transitionDuration || 250;
		this.init();
	}

	/**
	 * @description The setup of the javascript for the menu
	 */
	init() {
		if (!this.trigger) {
			console.warn(`No trigger found for location: ${this.location}`);
		}
		this.trigger.on("click", (e) => {
			e.stopPropagation();
			this.toggle();
		});

		this.dropdown.on("click", (e) => {
			e.stopPropagation();
		});

		this.options = this.getOptions();
	}

	/**
	 * @description Gets the language switcher trigger
	 * @returns the language switcher trigger element
	 */
	getTrigger() {
		return this.element.find($(`.${this.prefix}__trigger`));
	}

	/**
	 * @description Gets the language switcher menu
	 * @returns the dropdown menu element
	 */
	getDropdown() {
		return this.element.find($(`.${this.prefix}__list`));
	}

	/**
	 * @description Gets the available options in the `LanguageSwitcher`
	 * @returns all the available options
	 */
	getOptions() {
		const options = [];
		this.element.find($("[data-lang]")).each(function () {
			options.push(new LanguageSwitcherLink($(this)));
		});
		return options;
	}

	/**
	 * @description Loops through the options
	 * @param {(option:LanguageSwitcherLink) => {}} callback
	 */
	loopOptions(callback) {
		this.options.forEach((option) => {
			callback(option);
		});
	}

	/**
	 * @description Trigger the language switcher menu
	 */
	toggle() {
		this.element.toggleClass("open");
		this.openState = !this.openState;

		if (this.openState) {
			this.onOpen();
		} else {
			this.onClose();
		}
	}

	/**
	 * @description How to react when the menu opens
	 */
	onOpen() {
		this.dropdown.slideDown(this.transitionDuration);
		// this.dropdown.show();
	}

	/**
	 * @description How to react when the menu closes
	 */
	onClose() {
		this.dropdown.slideUp(this.transitionDuration);
		// this.dropdown.hide();
	}

	/**
	 * @description Force open the language switcher menu
	 */
	forceOpen() {
		this.element.addClass("open");
		if (!this.openState) this.onOpen();
		this.openState = true;
	}

	/**
	 * @description Force close the language switcher menu
	 */
	forceClose() {
		this.element.removeClass("open");
		if (this.openState) this.onClose();
		this.openState = false;
	}

	/**
	 * @description Returns the location of the switcher (if its defined). Example "header" or "sidebar" (depends on where its used)
	 * @returns The location of the language switcher
	 */
	getLocation() {
		return this.location;
	}

	/**
	 * @description Returns the open state of the language switcher
	 */
	isOpen() {
		return this.openState;
	}
}

class LanguageSwitcherLink {
	/**
	 * @description Object that contains function to the language switcher links
	 * @param {HTMLElement} element - The option element
	 */
	constructor(element) {
		this.element = element;
		const href = this.element.attr("href") || this.element.attr("data-href");
		if (!href) {
			console.warn("LanguageSwitcherLink created with no href or data-href attribute");
			return;
		}

		this.href = this.ensureProtocol(href);
		this.url = new URL(this.href);
		this.lang = this.element.attr("data-lang");
		this.active = parseFloat(this.element.attr("data-active"))
			? true
			: false;
	}

	/**
	 * @param {String} url
	 * @returns returns a valid url
	 * @todo consider try catch `new URL()`
	 */
	ensureProtocol(url) {
		const regex = new RegExp(/^((https)|(http))/);
		const hasProtocol = regex.test(url);

		if (hasProtocol) {
			return url;
		}

		if (url.startsWith("//")) {
			return `https:${url}`;
		}

		return `https://${url}`;
	}

	/**
	 * @description Takes the new url and updates the parameters on the link element
	 * @param {String} rawUrl String of the new url
	 */
	updateParameters(rawUrl) {
		const newUrl = new URL(rawUrl);
		this.url = new URL(this.url.origin + this.url.pathname + newUrl.search);
		this.onURLChange();
	}

	/**
	 * Function that should be triggered on url change
	 */
	onURLChange() {
		this.element.attr("href", this.url.href);
	}
}
